import createContextProxy from 'src/state/context/contextProxy'
import type { ContentType } from 'src/state/context/ContentProvider/ContentProvider'

const contentProvider = createContextProxy<ContentType>('Content')

export const ContentContext = contentProvider.ContextProxy
export const ContentProvider = contentProvider.ContextProxyProvider
export const useContent = contentProvider.useProxy
